import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { UserNotificationEmailResource } from 'dy-frontend-http-repository/lib/modules/UserNotificationEmail/resources';
import domain from './domain';
import { resetNotificationEmails } from './events';

// Notification emails
export const $notificationEmails = domain
    .createStore<CollectionResource<UserNotificationEmailResource, {}> | null>(null)
    .reset(resetNotificationEmails);
